import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { KYMW1400KomaPageComponent } from '../kymw1400-koma-page/kymw1400-koma-page.component';
import { KYMW1400Model } from '../kymw1400.model';


/**
 * コマ割（左ページ）を管理するクラス
 *
 * @export KYMW1400KomaPageLeftComponent
 * @class KYMW1400KomaPageLeftComponent
 */
@Component({
  selector: 'app-kymw1400-koma-page-left',
  templateUrl: 'kymw1400-koma-page-left.component.html',
  styleUrls: ['kymw1400-koma-page-left.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1400KomaPageLeftComponent {
  @ViewChild('KYMW1400KomaPageLeftViewHelper', { static: true }) KYMW1400KomaPageLeftViewHelper: KYMW1400KomaPageComponent;

  /**
   *Creates an instance of KYMW1400KomaPageLeftComponent.
   * @param {KYMW1400Model} kymw1400Model
   * @memberof KYMW1400KomaPageLeftComponent
   */
  constructor(
    private kymw1400Model: KYMW1400Model,
  ) {
  }

  /**
   * 【ページエリア】をユーザーがクリックした時
   */
  public eventWindow_MOUSE_DOWNHandler(): void {
    // ヘッダの選択色変更
    this.kymw1400Model.leftManage.selectedBarStyle = 'selectedBarColor';
    this.kymw1400Model.rightManage.selectedBarStyle = 'noSelectedBarColor';

    if (!this.kymw1400Model.leftPageSelected) {
      // ページ選択フラグを設定する
      this.kymw1400Model.leftPageSelected = true;

      // 画面メニュー、ボタンの活性化・非活性化制御を行う
      this.kymw1400Model.updateMenuAndButtonEnable();

      // モードレスでポップアップしている画面を再表示する。
      this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog();
    }

    this.kymw1400Model.leftView.page.selected = true;
    this.kymw1400Model.rightView.page.selected = false;
  }
}
